import React, { Component } from 'react';
import UnregisterRequest from './UnregisterRequest';
import ArrivedMilestone from './ArrivedMilestone';
import InvoiceData from './InvoiceData';
import InvoicedUnreturned from './InvoicedUnreturned';
import ReturnedData from './ReturnedData';
import { genModules, genSubAuth } from '../constants';

class RequestToDo extends Component {
    constructor(props) {
        super(props);
        const { auth } = props;
        const modules = [{
            key: 'unregisterRequest',
            Content: UnregisterRequest,
        }, {
            key: 'arrivedMilestone',
            Content: ArrivedMilestone,
        }, {
            key: 'invoiceData',
            Content: InvoiceData,
        }, {
            key: 'invoicedUnreturned',
            Content: InvoicedUnreturned,
        }, {
            key: 'returnedData',
            Content: ReturnedData,
        }];

        this.modules = genModules(modules, auth);
    }

    render() {
        const { auth } = this.props;
        const modules = this.modules.map(item => {
            const { key, Content } = item;
            return <Content key={key} auth={genSubAuth(auth, key)} />;
        });
        return (
            <div className="pane">
                {modules}
            </div>
        );
    }
}

export default RequestToDo;


// WEBPACK FOOTER //
// ./src/components/RequestDataAnalysis/RequestToDo/index.js